// Email-link sign-in authenticates against a Firebase Auth UID that's unrelated to
// the user's real (phone-registered) account/UID — the rest of the app assumes
// users/{uid} === fbAuth.currentUser.uid, which is only true for phone auth. Once
// the email-link flow resolves the real user (see fbGetUserByPhone), it stores that
// real UID here so login/routing code can use it instead of the fresh, unrelated
// Auth UID. Uses localStorage so it survives the page navigation from the email
// client back into the app, and is cleared for free by logoutUser()'s existing
// localStorage.clear().
const STORAGE_KEY = "emailAuthUidOverride";

export const setEmailAuthUidOverride = (uid) => {
  try {
    localStorage.setItem(STORAGE_KEY, uid);
  } catch {
    // localStorage unavailable (e.g. private browsing) — override simply won't persist.
  }
};

export const getEmailAuthUidOverride = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const clearEmailAuthUidOverride = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
};
